/** 클라이언트 ID → 아이콘 적용 (SessionTimeline 등에서 사용) */
export const KNOWN_CLIENT_IDS = ['mv-agent-desktop-1.0.0-arm64'] as const;

export function isKnownClientId(value: string): boolean {
  return (KNOWN_CLIENT_IDS as readonly string[]).includes(value);
}
